import * as React from 'react';
import { observer } from 'mobx-react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { MapSection } from '../trial6/map/MapSection';

export const AccessPage = withNavigation(NavigationSpecs.standard())(
  observer(
    class AccessPage extends React.Component {
      render() {
        return <MapSection />;
      }
    }
  )
);
